module.exports = __webpack_public_path__ + "static/media/donbosco8.d2994ad6.jpg";